module.exports = {"140703101":"胡村镇","140703102":"范村镇","140703103":"水秀镇","140703200":"侯城乡","140703201":"北汪乡","140703203":"阳邑乡","140703204":"小白乡","140703205":"任村乡","140703401":"白塔区","140703402":"北城区","140703403":"南城区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140703.json
// module id = 410
// module chunks = 0